__turbopack_context__.v({
  "alert": "Alert-module-scss-module__f3YVua__alert",
  "alertCaution": "Alert-module-scss-module__f3YVua__alertCaution",
  "alertCritical": "Alert-module-scss-module__f3YVua__alertCritical",
  "alertInfo": "Alert-module-scss-module__f3YVua__alertInfo",
  "alertSuccess": "Alert-module-scss-module__f3YVua__alertSuccess",
  "body": "Alert-module-scss-module__f3YVua__body",
  "closeButton": "Alert-module-scss-module__f3YVua__closeButton",
  "content": "Alert-module-scss-module__f3YVua__content",
  "fade-in": "Alert-module-scss-module__f3YVua__fade-in",
  "heading": "Alert-module-scss-module__f3YVua__heading",
  "no-transform": "Alert-module-scss-module__f3YVua__no-transform",
  "rotate": "Alert-module-scss-module__f3YVua__rotate",
});
